import { gql } from '@apollo/client';

export const TAG_FIELDS = gql`
  fragment tagFields on TagV2 {
    id
    displayName
    category {
      id
      name
    }
  }
`;

export const SUB_MGMT_SUBSCRIPTION_FIELDS = gql`
  fragment subMgmtFields on SubscriptionEntityV2 {
    uuid
    startWeek
    endWeek
    legacyOrderId
    displayName
    status
    carts {
      status
      customizeBy
    }
    orders(count: 1, statuses: [PROCESSED, FAILED_PROCESSING]) {
      fulfilled
      cart {
        status
        customizeBy
      }
    }
    cancellation {
      createdAt
    }
    subscriptionDeliveries {
      day
      quantity
    }
    metro {
      legacyRailsId
    }
    location {
      city
      state
      zip
      addressLine1
      addressLine2
      recipient
      phone
      dropoffLocation
    }
    preferences {
      ingredientsToAvoid {
        legacyAllergenItemId
        displayName
        isAllergen
        category {
          legacyAllergenCategoryId
          displayName
        }
      }
      dietaryTemplates: tags(categoryName: "DIETARY_TEMPLATE") {
        ...tagFields
      }
      mealTypes: tags(categoryName: "MEAL_TYPE") {
        ...tagFields
      }
      tags {
        ...tagFields
      }
    }
    paymentMethod {
      ... on ApplePayV2 {
        displayName
        network
        expirationMonth
        expirationYear
        lastFour
      }
      ... on CreditCardV2 {
        displayName
        network
        expirationMonth
        expirationYear
        lastFour
      }
      ... on PayPalV2 {
        displayName
        email
      }
    }
  }
`;

export const DASHBOARD_SUBSCRIPTION_FIELDS = gql`
  fragment dashboardSubscription on SubscriptionEntityV2 {
    uuid
    startWeek
    endWeek
    legacyOrderId
    displayName
    status
    metro {
      legacyRailsId
      shoppableDeliveryDates
      legacySystemShoppableDeliveryDates
      currentModifyDeadline
    }
    location {
      city
      state
      zip
      addressLine1
      addressLine2
      recipient
      dropoffLocation
    }
    paymentMethod {
      ... on ApplePayV2 {
        displayName
        expirationMonth
        expirationYear
        lastFour
        network
      }
      ... on CreditCardV2 {
        displayName
        expirationMonth
        expirationYear
        lastFour
        network
      }
      ... on PayPalV2 {
        displayName
        email
      }
    }
    mealsPerWeek
    preferences {
      ingredientsToAvoid {
        displayName
      }
      dietaryTemplates: tags(categoryName: "DIETARY_TEMPLATE") {
        ...tagFields
      }
      mealTypes: tags(categoryName: "MEAL_TYPE") {
        ...tagFields
      }
    }
    pauses
    carts(excludeProcessed: true) {
      uuid
      userId
      orderOn
      customizeBy
      deliveryDates
      deliveryWeek
      createdAt
      legacyOrderId
      cartDeliveries {
        id
        createdAt
        updatedAt
        orderDelivery {
          trackingId
          trackingUrl
        }
        locationId
        status
        deliveryType
        estimatedTransitTime
        estimatedDeliveryDate
        deliveryDate
        lineItems {
          id
          createdAt
          updatedAt
          variantId
          price
          quantity
        }
      }
      funnelData
      cartLedger {
        id
        createdAt
        updatedAt
        subtotal
        discountTotal
        deliveryTotal
        tax
        grandTotal
        creditTotal
        precreditTotal
      }
      discount {
        amount
        code
        type
      }
      cartError {
        validation {
          quantity {
            message
            deliveryId
          }
          status {
            message
          }
          catalog {
            message
          }
          customizeBy {
            message
          }
        }
      }
    }
    orders(count: 8) {
      fulfilled
      cart {
        uuid
        userId
        orderOn
        customizeBy
        deliveryDates
        deliveryWeek
        createdAt
        legacyOrderId
        cartDeliveries {
          id
          createdAt
          updatedAt
          orderDelivery {
            trackingId
            trackingUrl
          }
          locationId
          status
          deliveryType
          estimatedTransitTime
          estimatedDeliveryDate
          deliveryDate
          lineItems {
            id
            createdAt
            updatedAt
            variantId
            price
            quantity
          }
        }
        funnelData
        cartLedger {
          id
          createdAt
          updatedAt
          subtotal
          discountTotal
          deliveryTotal
          tax
          grandTotal
          creditTotal
          precreditTotal
        }
        discount {
          amount
          code
          type
        }
        cartError {
          validation {
            quantity {
              message
              deliveryId
            }
            status {
              message
            }
            catalog {
              message
            }
            customizeBy {
              message
            }
          }
        }
      }
    }
  }
`;
